// src/pages/cashier/LoungeEOD.jsx
import React from 'react';
import EndOfDay from '../EndOfDay';

const LoungeEOD = () => {
  return <EndOfDay locationKey="lounge" />;
};

export default LoungeEOD;